export default function FlagModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/50 z-50" onClick={onClose} />

      {/* Modal */}
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        onClick={onClose}
      >
        <div
          className="bg-white dark:bg-lz-ink-mid text-lz-ink-mid dark:text-white rounded-2xl p-6 shadow-lg w-96"
          onClick={(e) => e.stopPropagation()}
        >
          <h3 className="text-xl font-semibold mb-4">Post Flagged</h3>
          <p className="mb-6">
            This post doesn&apos;t pass our community guidelines.
          </p>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-lz-ember dark:bg-lz-ink-mid text-white hover:opacity-80 rounded-lg transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
